export enum ExperimentFlag {
  velocityCheck = 'velocityCheck',
  version = 'version',
  contentMobileOffsetMultiplier = 'content_mobile offset multiplier',
  contentBtfOffsetMultiplier = 'content_btf offset multiplier',
  contentMobileTimeout = 'Content Mobile Timeout',
  s2s = 'Prebid Server-to-Server',
  s2sBidders = 'Prebid S2S Bidders',
  s2sBeta = 's2sBeta',
  recipeOffset = 'Recipe Offset Multiplier'
}
